var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTurkmenistan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3a8343",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c23635",
    d: "M5 0h5v24H5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.14 3.46a4.15 4.15 0 0 1-4.33 6.98 4.15 4.15 0 1 0 4.33-6.98M14.18 6.5l.18-.55h.58l-.47-.34.18-.56-.47.34-.47-.34.18.56-.47.34H14zM14 3.82l.18.56.18-.56h.58l-.47-.34.18-.55-.47.34-.47-.34.18.55-.47.34zm2.1 1.1.19.55.18-.55h.58l-.47-.35.18-.55-.47.34-.47-.34.18.55-.47.35zm-3.74 1.74.18-.56-.47.35-.47-.35.18.56-.47.34h.58l.18.55.18-.55h.58zm1.82 1.99.18-.56h.58l-.47-.34.18-.55-.47.34-.47-.34.18.55-.47.34H14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkmenistan);
export default __webpack_public_path__ + "static/media/turkmenistan.734f4b56f44fe4c4fc608633406eefd6.svg";
export { ForwardRef as ReactComponent };